const DE_CASES = ['BRE', 'HAJ', 'AE7B', 'NDCSQ', 'ETVQ', 'AFBM', 'EJFT', 'BYOF'];
const AT_CASES = ['BRE', 'VIE', 'ESUY', 'INNTU310E', 'AFB5', 'EJFT'];
const CH_CASES = ['ZRH', 'AD2Q', 'AJ7P', 'ETL5', 'BB0W', 'ADKZ'];
export const GAS_CASES = [...DE_CASES, ...AT_CASES, ...CH_CASES];

const BE_CASES = ['ANR'];
const NL_CASES = ['AMS', 'ENS'];
export const BENE_CASES = [...BE_CASES, ...NL_CASES];
